import { render, staticRenderFns } from "./PccOrderAgreementProperties.vue?vue&type=template&id=62922a3d&scoped=true&"
import script from "./PccOrderAgreementProperties.vue?vue&type=script&lang=js&"
export * from "./PccOrderAgreementProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62922a3d",
  null
  
)

export default component.exports